import '../configuracoes.css'
import trashIcon from '../../../imagens/trash.png'

import toast from 'react-hot-toast';
import { useState, useEffect } from 'react';

import { servDelPontoFacultativo, servGetPontosFacultativosMes } from '../../../servicos/servicosEmRotasPrivadas/pontoFacultativo';
import { toastErrorPydantic } from '../../../util/toast_pydantic';

import DataMesControlled from '../../DataMesControlled';
import TituloSessao from '../../TituloSessao';
import IndicadorBuscaFiltros from '../../IndicadorBuscaFiltros';
import {
    servGetIndicadorComAjustes,
    servPostIndicadorAjusteExcepcional
} from '../../../servicos/servicosEmRotasPrivadas/indicador';
import { formataDatetime } from '../../../util/datas';

function IndicadorAjusteExcepcional() {

    const initialQuery = {
        mesReferencia: null,
        estabelecimento: null,
        metricaCodigo: null
    }

    const [indicador, setIndicador] = useState(null);
    const [motivoAjusteExcepcional, setMotivoAjusteExcepcional] = useState(null);
    const [query, setQuery] = useState(initialQuery);

    useEffect(() => {

        if (query.mesReferencia && query.estabelecimento && query.metricaCodigo) {
            getIndicador()
        } else {
            if (indicador) setIndicador(null) // Caso o usuário limpe qualquer filtro, deve desconsiderar o indicador
            // Mas, apenas se algum indicador estiver setado, não faz sentido fazer set null em algo que já é null
        }

    }, [query]);

    const getIndicador = async () => {

        const { estabelecimento, ...resto } = query;
        const queryFinal = { ...resto, estabelecimentoId: estabelecimento?.id };

        try {
            const response = await toast.promise(
                servGetIndicadorComAjustes(queryFinal),
                { loading: 'Buscando indicador...' }
            )
            setIndicador(response);
        } catch (error) {
            toastErrorPydantic(error)
            setIndicador(null);
        }
    }

    async function postIndicadorAjusteExcepcional() {

        const request = {
            indicadorId: indicador.id,
            motivo: motivoAjusteExcepcional
        }

        try {
            await servPostIndicadorAjusteExcepcional(request)
            toast.success('Ajuste excepcional cadastrado com sucesso!')
            setQuery(initialQuery)
        } catch (error) {
            toastErrorPydantic(error)
        }
    }

    function updateFiltro(nome, valor) {
        setQuery(prev => ({
            ...prev,
            [nome]: valor
        }))
    }

    return (
        <div className='d-flex flex-column gap-3'>

            <div className='container-configuracoes div-com-borda'>
                <strong>
                    <p className='m-0 fs-5'>Busque o indicador que necessita de ajuste fora do prazo</p>
                </strong>
                <IndicadorBuscaFiltros
                    // metrica
                    metricaCodigo={query.metricaCodigo}
                    metricaOnChange={
                        (v) => updateFiltro("metricaCodigo", v)
                    }
                    // mes referencia
                    mesReferencia={query.mesReferencia}
                    mesReferenciaOnChange={
                        (v) => updateFiltro("mesReferencia", v)
                    }
                    // estabelecimento
                    estabelecimento={query.estabelecimento}
                    estabelecimentoOnChange={
                        (v) => updateFiltro("estabelecimento", v)
                    }
                />

            </div>

            {indicador &&
                <div className=''>

                    <div className="fs-6 m-0 div-com-borda container-configuracoes">
                        <strong>Encontrei o indicador!</strong> Informe o motivo do ajuste e clique no botão para criar um ajuste excepcional com validade de três dias úteis.
                        <div>

                            <label
                                htmlFor="motivo"
                                className="form-label"
                            >
                                Motivo
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                id="motivo"
                                value={motivoAjusteExcepcional}
                                onChange={(e) => setMotivoAjusteExcepcional(e.target.value || "")}
                            />

                        </div>

                        <button
                            className='btn btn-primary'
                            onClick={() => postIndicadorAjusteExcepcional()}
                        >
                            CRIAR
                        </button>
                    </div>

                    <TituloSessao
                        titulo='Ajustes cadastrados para o indicador'
                        barraDecorativa={false}
                        tituloAlignStar={false}
                        paddingBottom={false}
                    />

                    <div className="div-com-borda container-configuracoes">
                        {indicador.ajustesExcepcionais.length > 0
                            ?
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Data de criação</th>
                                            <th scope="col">Data de expiração</th>
                                            <th scope="col">Motivo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {indicador.ajustesExcepcionais.map((ajuste) => (
                                            <tr
                                                key={ajuste.id}
                                            >
                                                <td>{formataDatetime(ajuste.createDate)}</td>
                                                <td>{formataDatetime(ajuste.expDate)}</td>
                                                <td>{ajuste.motivo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <p className='m-0 fs-6'>Não encontrei ajustes cadastrados para o indicador.</p>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default IndicadorAjusteExcepcional
